import "./appLoaderStyle.scss"

const AppLoader=()=>{
    return(
        <div className="loading-One bulk-barcode-loading">
          <div
            className="spinner-border text-primary loading-Two bulk-lost-barcode-container"
            role="status"
          >
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
    )
}

export default AppLoader